var Message       = require("app/ui/Message"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    kind          = require("enyo/kind");

module.exports = kind(/** @lends  app.SearchPage.NoResultsView.prototype */ {

    /**
     * @private
     */
    name: "app.SearchPage.NoResultsView",

    /**
     * @private
     */
    kind: Message,

    /**
     * @private
     */
    classes: "app-search-page-no-results-view",

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService;

        this.$.title.set("content", i18nService.getString("app.SearchPage.NoResults.title"));
        this.$.body.set("content", i18nService.getString("app.SearchPage.NoResults.body"));
    }

});
